import React, { useState, useEffect, useRef } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck, faTimes, faFileAlt, faFileExcel, faFileWord,
  faDownload, faSearch, faPlus, faFileUpload, faChartLine,
  faExclamationCircle, faExclamationTriangle, faInfoCircle,
  faClipboardCheck, faEllipsisV, faFilePdf, faSync,
  faChevronDown, faFilter, faUser, faEnvelope, faPhone,
  faMapMarkerAlt, faGlobe, faCalendarCheck, faFileContract,
  faUserTie, faSitemap, faCalendarAlt, faCheckCircle,
  faExternalLinkAlt, faShieldAlt, faBuilding, faEye
} from '@fortawesome/free-solid-svg-icons';
import { useSelector, useDispatch } from "react-redux";
import { requestPrivatePolicy, getCertificateAssessmentHistory, getCertificateFindingsCritical, getCertificateSubOrg, deleteDocument, getCertificateDataAccess } from "../../actions/riskManagement";
import { fetchCustomersById } from "../../actions/customer";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import Pagination from "../Pagination/Pagination";
import profilePlaceholder from "../../assets/images/dummyImage.png";
import axios from 'axios';
import { API_URL } from '../../utils/constant';
import { fetchRatingData } from '../../actions/summary';

// Register ChartJS components safely
try {
    if (ChartJS && typeof ChartJS.register === 'function') {
        // Check if components are already registered to prevent conflicts
        const registry = ChartJS.registry;
        if (registry && registry.scales) {
            if (!registry.scales.get('category')) {
                ChartJS.register(CategoryScale);
            }
            if (!registry.scales.get('linear')) {
                ChartJS.register(LinearScale);
            }
        }
        if (registry && registry.elements) {
            if (!registry.elements.get('bar')) {
                ChartJS.register(BarElement);
            }
        }
        if (registry && registry.plugins) {
            if (!registry.plugins.get('title')) {
                ChartJS.register(Title);
            }
            if (!registry.plugins.get('tooltip')) {
                ChartJS.register(Tooltip);
            }
            if (!registry.plugins.get('legend')) {
                ChartJS.register(Legend);
            }
        }
    }
} catch (error) {
    // console.warn removed
}

const VendorRiskDetails = () => {
  const _id = useSelector(state => {
    return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
  });
  const [activeTab, setActiveTab] = useState('critical');
  const [filterOpen, setFilterOpen] = useState(false);
  const dropdownRef = useRef(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const [totalItems, setTotalItems] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const { id } = useParams();
  const certificate = useSelector((state) => state?.riskManagement?.certificate);
  const certificateAssessmentHistory = useSelector((state) => state?.riskManagement?.assessmentHistory);
  const criticalFindings = useSelector((state) => state?.riskManagement?.criticalFindings?.data);
  const certificateDataAccess = useSelector((state) => state?.riskManagement?.certificateDataAccess?.data);
  const customer = useSelector((state) => state?.customer?.fetechCustomerById?.data?.[0]);
  const [findingsPage, setFindingsPage] = useState(1);
  const [findingsLimit, setFindingsLimit] = useState(5);
  const [totalFindings, setTotalFindings] = useState(0);
  const [searchName, setSearchName] = useState("");
  const [threatIntelData, setThreatIntelData] = useState(null);
  const [isLoadingThreatIntel, setIsLoadingThreatIntel] = useState(false);
  const [serviceProfiles, setServiceProfiles] = useState([]);
  const [serviceProfilesLoading, setServiceProfilesLoading] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [serviceProfilesPage, setServiceProfilesPage] = useState(1);
  const [serviceProfilesLimit, setServiceProfilesLimit] = useState(10);
  const [totalServiceProfiles, setTotalServiceProfiles] = useState(0);
  const ratingData = (useSelector(state => state?.summary?.ratingData?.totalScoreDashboard?.attackSurfaceSecurityImpact + state?.summary?.ratingData?.totalScoreDashboard?.darkWebSecurityImpact)).toFixed(2);
  const org = JSON.parse(localStorage.getItem("org") || "{}");

  const getSeverityInfo = (riskLevel) => {
    const level = riskLevel?.toLowerCase() || "medium";

    switch (level) {
      case 'high':
        return {
          icon: faExclamationCircle,
          bgColor: 'bg-danger',
          textColor: 'text-danger',
          badgeClass: 'badge-danger',
          borderClass: 'border-danger',
          label: 'High'
        };
      case 'medium':
        return {
          icon: faExclamationTriangle,
          bgColor: 'bg-warning',
          textColor: 'text-warning',
          badgeClass: 'badge-warning',
          borderClass: 'border-warning',
          label: 'Medium'
        };
      case 'low':
        return {
          icon: faInfoCircle,
          bgColor: 'bg-info',
          textColor: 'text-info',
          badgeClass: 'badge-info',
          borderClass: 'border-info',
          label: 'Low'
        };
      default:
        return {
          icon: faExclamationTriangle,
          bgColor: 'bg-secondary',
          textColor: 'text-secondary',
          badgeClass: 'badge-secondary',
          borderClass: 'border-secondary',
          label: 'Unknown'
        };
    }
  };

  // Add this helper function with your other helper functions
  const getCertificateClass = (certificateName) => {
    const certName = (certificateName || '').toLowerCase();

    if (certName.includes('iso')) return 'ved-cert-iso';
    if (certName.includes('soc') || certName.includes('soc2')) return 'ved-cert-soc';
    if (certName.includes('nist')) return 'ved-cert-nist';
    if (certName.includes('cis')) return 'ved-cert-cis';
    if (certName.includes('gdpr')) return 'ved-cert-gdpr';
    if (certName.includes('pci')) return 'ved-cert-pci';
    if (certName.includes('hipaa')) return 'ved-cert-hipaa';

    return 'ved-cert-default';
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setFilterOpen(false);
      }
    }


    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (id) {
      fetchRatingData(id,'', dispatch);
    }
  }, [id]);

  const fetchServiceProfiles = async (page = 1, limit = 10) => {
    if (!id) return;
    try {
      setServiceProfilesLoading(true);
      const session = localStorage.getItem("session");
      const response = await axios.get(
        `${API_URL}/tprm/vendors/${id}/service-profiles?page=${page}&limit=${limit}`,
        {
          headers: {
            Authorization: `Bearer ${session}`
          }
        }
      );
      setServiceProfiles(response?.data?.data?.serviceProfiles || []);
      setTotalServiceProfiles(response?.data?.data?.totalServiceProfiles || 0);
      setServiceProfilesLoading(false);
    } catch (error) {
      // console.error removed
      setServiceProfiles([]);
      setTotalServiceProfiles(0);
      setServiceProfilesLoading(false);
    }
  };

  useEffect(() => {
    if (id && _id) {
      getCertificateSubOrg(_id, id, dispatch, page, 100, searchName);
    }
  }, [_id, id, page, searchName]);


  useEffect(() => {
    if (id && _id) {
      getCertificateFindingsCritical(_id, id, dispatch, findingsPage, findingsLimit);
    }
  }, [_id, id, findingsPage, findingsLimit]);


  useEffect(() => {
    if (id) {
      fetchCustomersById(id, dispatch);
    }
  }, [id]);

  useEffect(() => {
    setTotalItems(certificate?.data?.pagination?.total);
  }, [certificate]);


  useEffect(() => {
    if (id && _id) {
      getCertificateAssessmentHistory(_id, id, dispatch, page, limit);
    }
  }, [id, _id]);

  useEffect(() => {
    if (id && _id) {
      getCertificateDataAccess(_id, id, dispatch);
    }
  }, [id, _id]);


  useEffect(() => {
    if (criticalFindings?.totalRecords) {
      setTotalFindings(criticalFindings.totalRecords);
    }
  }, [criticalFindings]);

  useEffect(() => {
    if (id && _id) {
      setIsLoadingThreatIntel(true);

      axios.get(`${API_URL}/forest-view/organisations/${_id}/risk-distribution?organisations=${id}`)
        .then(response => {
          setThreatIntelData(response.data);
          setIsLoadingThreatIntel(false);
        })
        .catch(error => {
          // console.error removed
          setIsLoadingThreatIntel(false);
        });
    }
  }, [id, _id]);

  useEffect(() => {
    if (id && _id) {
      fetchServiceProfiles(serviceProfilesPage, serviceProfilesLimit);
    }
  }, [id, _id, serviceProfilesPage, serviceProfilesLimit]);

  // Auto-switch to External Security Risks tab if vendor questionnaire is disabled
  useEffect(() => {
    if (org.isVendorQuestionairreDisabled === true) {
      setActiveTab('threatIntel');
    }
  }, [org.isVendorQuestionairreDisabled]);

  // Sample vendor data
  const vendor = {
    id: "v12345",
    name: "CloudTech Inc.",
    description: "Cloud Infrastructure Provider",
    logo: "/assets/images/vendor-logo.png",
    riskLevel: "High Risk",
    tier: "Tier 1",
    contact: {
      name: "Sarah Johnson",
      title: "CISO",
      email: "s.johnson@cloudtech.example",
      phone: "+1 (555) 123-4567",
      location: "San Francisco, CA",
      website: "cloudtech.example"
    },
    relationship: {
      onboarded: "Jan 15, 2024",
      renewal: "Dec 31, 2025",
      owner: "Michael Chen",
      department: "IT Infrastructure"
    },
    dataAccess: {
      customerData: true,
      financialInformation: true,
      intellectualProperty: true,
      healthcareInformation: false,
      paymentCardData: false
    },
    riskScores: {
      overall: 78,
      security: 782,
      compliance: 85,
      business: 90,
      lastUpdated: "May 2, 2025"
    },
    criticalFindings: [
      {
        id: "cf001",
        title: "Vulnerable S3 Bucket Configurations",
        description: "External scan detected publicly accessible storage buckets containing potentially sensitive data.",
        severity: "High",
        detected: "Apr 28, 2025",
        source: "External Scan"
      },
      {
        id: "cf002",
        title: "Inadequate Encryption Key Management",
        description: "Questionnaire responses indicate non-compliance with industry standards for encryption key rotation and storage.",
        severity: "High",
        detected: "May 1, 2025",
        source: "SOC 2 Assessment"
      },
      {
        id: "cf003",
        title: "Incomplete Access Control Documentation",
        description: "Vendor has not provided sufficient documentation on access control procedures for customer data.",
        severity: "Medium",
        detected: "Apr 25, 2025",
        source: "Document Review"
      }
    ]
  };

  // Sample assessments data
  const assessments = [
    {
      id: "a001",
      name: "Annual Security Assessment",
      reference: "2025 Q2",
      framework: "SOC 2",
      status: "Completed",
      completion: 100,
      riskScore: 78,
      riskLevel: "High",
      startDate: "Apr 10, 2025",
      completionDate: "May 1, 2025"
    },
    {
      id: "a002",
      name: "Quarterly Compliance Review",
      reference: "2025 Q1",
      framework: "ISO 27001",
      status: "Completed",
      completion: 100,
      riskScore: 65,
      riskLevel: "Medium",
      startDate: "Jan 15, 2025",
      completionDate: "Feb 28, 2025"
    },
    {
      id: "a003",
      name: "Annual Security Assessment",
      reference: "2024 Q2",
      framework: "SOC 2",
      status: "Completed",
      completion: 100,
      riskScore: 42,
      riskLevel: "Low",
      startDate: "Apr 15, 2024",
      completionDate: "May 10, 2024"
    }
  ];

  // Sample documents data
  const documents = [
    {
      id: "d001",
      name: "SOC 2 Type II Report",
      type: "PDF",
      size: "2.4 MB",
      uploadedDate: "May 1, 2025",
      framework: "SOC 2"
    },
    {
      id: "d002",
      name: "Vulnerability Scan Results",
      type: "XLSX",
      size: "1.8 MB",
      uploadedDate: "Apr 28, 2025",
      framework: "Security"
    },
    {
      id: "d003",
      name: "Data Processing Agreement",
      type: "DOCX",
      size: "520 KB",
      uploadedDate: "Feb 15, 2025",
      framework: "GDPR"
    }
  ];

  // Chart data
  const chartData = {
    labels: ['Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [
      {
        data: [65, 59, 80, 60, 56, 86, 92],
        backgroundColor: [
          '#3b82f6', '#3b82f6', '#3b82f6', '#3b82f6', '#3b82f6', '#ef4444', '#ef4444'
        ],
        borderColor: 'transparent',
        borderRadius: 4,
        barThickness: 25,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          title: function (context) {
            return `${context[0].label} 2025`;
          },
          label: function (context) {
            return `Risk Score: ${context.raw}/100`;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 100,
        grid: {
          display: false,
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
  };

  // Helper function to get file type information
  const getFileTypeInfo = (fileNameOrExt) => {
    const ext = fileNameOrExt.toLowerCase();

    // Configuration for different file types
    const fileTypes = {
      pdf: {
        icon: 'fa-file-pdf',
        color: '#08283f',
        bgColor: '#08283f2b',
        label: 'PDF'
      },
      doc: {
        icon: 'fa-file-word',
        color: '#08283f',
        bgColor: '#08283f2b',
        label: 'DOC'
      },
      docx: {
        icon: 'fa-file-word',
        color: '#08283f',
        bgColor: '#08283f2b',
        label: 'DOCX'
      },
      xls: {
        icon: 'fa-file-excel',
        color: '#08283f',
        bgColor: '#08283f2b',
        label: 'XLS'
      },
      xlsx: {
        icon: 'fa-file-excel',
        color: '#08283f',
        bgColor: '#08283f2b',
        label: 'XLSX'
      },
      ppt: {
        icon: 'fa-file-powerpoint',
        color: '#08283f',
        bgColor: '#08283f2b',
        label: 'PPT'
      },
      pptx: {
        icon: 'fa-file-powerpoint',
        color: '#08283f',
        bgColor: '#08283f2b',
        label: 'PPTX'
      },
      txt: {
        icon: 'fa-file-alt',
        color: '#08283f',
        bgColor: '#08283f2b',
        label: 'TXT'
      },
      csv: {
        icon: 'fa-file-csv',
        color: '#08283f',
        bgColor: '#08283f2b',
        label: 'CSV'
      },
      zip: {
        icon: 'fa-file-archive',
        color: '#08283f',
        bgColor: '#08283f2b',
        label: 'ZIP'
      },
      default: {
        icon: 'fa-file',
        color: '#08283f',
        bgColor: '#08283f2b',
        label: 'File'
      }
    };

    // Check if it's a known file type
    for (const [type, info] of Object.entries(fileTypes)) {
      if (ext.includes(type)) {
        return info;
      }
    }

    return fileTypes.default;
  };

  // Helper function to format date
  const formatDate = (date) => {
    if (!date) return '';

    try {
      const d = new Date(date);
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
    } catch (e) {
      return '';
    }
  };

  // Helper function to get tag class based on document type
  const getTagClass = (type) => {
    const typeClasses = {
      'soc 2': 'tag-soc',
      'soc2': 'tag-soc',
      'security': 'tag-security',
      'gdpr': 'tag-gdpr',
      'policy': 'tag-policy',
      'bcp': 'tag-bcp',
      'bcp/dr': 'tag-bcp',
      'private': 'tag-private',
      'public': 'tag-public'
    };

    const lowerType = (type || '').toLowerCase();

    for (const [key, value] of Object.entries(typeClasses)) {
      if (lowerType.includes(key)) {
        return value;
      }
    }

    return 'tag-default';
  };

  // Prevent default on dropdown links
  const handleDropdownClick = (e) => {
    e.preventDefault();
  };

  // Add navigation function for risk types
  const handleRiskNavigation = (riskValue, organisations) => {
    if (riskValue == 'high-risk-vulnerability') {
      window.open(`/known-vulnerabilities/vendor/${organisations}`, '_blank');
    } else if (riskValue == 'Exploitable Obsolete Technology') {
      window.open(`/web-technology/vendor/${organisations}`, '_blank');
    } else if (riskValue == 'Dangling Subdomain') {
      window.open(`/subdomains/vendor/${organisations}`, '_blank');
    } else if (riskValue == 'expired-ssl-certificate') {
      window.open(`/vulnerable-certificates/vendor/${organisations}`, '_blank');
    } else if (riskValue == 'vulnerable-obsolete-technology') {
      window.open(`/web-technology/vendor/${organisations}`, '_blank');
    } else if (riskValue == 'stolen-cred') {
      window.open(`/stolen-credentials/vendor/${organisations}`, '_blank');
    } else if (riskValue == 'malware-cred') {
      window.open(`/malware-credentials/vendor/${organisations}`, '_blank');
    } else if (riskValue == 'leaked-session') {
      window.open(`/leaked-sessions/vendor/${organisations}`, '_blank');
    } else if (riskValue == 'Personal Information Breach') {
      window.open(`/pii/vendor/${organisations}`, '_blank');
    } else if (riskValue == 'Lookalike Domain') {
      window.open(`/look-alike/vendor/${organisations}`, '_blank');
    } else if (riskValue == 'Fake Social Media Profile') {
      window.open(`/social-media/vendor/${organisations}`, '_blank');
    } else if (riskValue == 'leaked-code') {
      window.open(`/source-code/vendor/${organisations}`, '_blank');
    } else if (riskValue == 'vulnerable-ssl-certificate') {
      window.open(`/vulnerable-certificates/vendor/${organisations}`, '_blank');
    } else if (riskValue == 'postman') {
      window.open(`/postman-monitoring/vendor/${organisations}`, '_blank');
    }
    else if (riskValue == 'dark-web-mention') {
      window.open(`/dark-web/vendor/${organisations}`, '_blank');
    } 
    else if (riskValue == 'personal-information-breach') {
      window.open(`/pii/vendor/${organisations}`, '_blank');
    }
    else if(riskValue == 'spf') {
      window.open(`/spf-dmarc/vendor/${organisations}`, '_blank');
    }
    else if(riskValue == 'dmarc') {
      window.open(`/spf-dmarc/vendor/${organisations}`, '_blank');
    }
  };

  // Add download report function
  const handleDownloadReport = async () => {
    try {
      const session = localStorage.getItem("session");
      const response = await axios.get(
        `${API_URL}/tprm/organisation/${_id}/vendor/${id}/consolidated-risk-distribution/excel`,
        {
          headers: {
            Authorization: `Bearer ${session}`
          },
          responseType: 'blob'
        }
      );

      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${customer?.orgName || 'vendor'} report.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error removed
      alert("Failed to download report. Please try again.");
    }
  };

  return (
    <div className="container-fluid">
      <div className="block-header">
        <div className="row clearfix">
          <div className="col-md-6 col-sm-12">
            <h2 className="welcome-text">Vendor Profile</h2>
            <nav aria-label="breadcrumb" className="mt-1">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/tprm/dashboard" className="welcome-textSmall">Third Party Risk Management</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/tprm/vendor" className="welcome-textSmall">Vendors</Link>
                </li>
                <li
                  className="breadcrumb-item active"
                  aria-current="page"
                  style={{ color: "white" }}
                >
                  {customer?.orgName}
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      {/* Vendor Profile Card */}
      <div className="card mb-4">
        <div className="card-body">
          <div className="row">
            {/* Left Column - Vendor Info */}
            <div className="col-lg-3 border-right">
              <div className="text-center mb-4">
                <div className="vendor-avatar mb-3">
                  <img
                    src={customer?.logoUrl || profilePlaceholder}
                    alt={customer?.orgName || vendor.name}
                    className="rounded-circle"
                    style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                  />
                </div>
                <h4 className="welcome-textSmall">{customer?.orgName}</h4>
                <p className="text-muted">{customer?.description || "No description available"}</p>
                <div className="vendor-badges">
                  <span className="badge badge-info">{customer?.vendorProfile?.tier}</span>
                </div>
                {customer?.industryType && (
                  <div className="industry-badge mt-2">
                    <span className="badge badge-light">
                      <FontAwesomeIcon icon={faBuilding} className="mr-1" />
                      {customer.industryType}
                    </span>
                  </div>
                )}
              </div>

              <h6 className="section-heading">CONTACT INFORMATION</h6>
              <ul className="list-unstyled contact-info">
                <li className="mb-2">
                  <FontAwesomeIcon icon={faUser} className="mr-2 text-muted" />
                  {customer?.orgContactName}
                  {customer?.orgContactName && customer?.orgContact && ", "}
                  {customer?.orgContact}
                </li>
                {customer?.orgEmail && (
                  <li className="mb-2">
                    <FontAwesomeIcon icon={faEnvelope} className="mr-2 text-muted" />
                    {customer.orgEmail}
                  </li>
                )}
                {customer?.address && (
                  <li className="mb-2">
                    <FontAwesomeIcon icon={faMapMarkerAlt} className="mr-2 text-muted" />
                    {customer.address}
                  </li>
                )}
                <li className="mb-2">
                  <FontAwesomeIcon icon={faGlobe} className="mr-2 text-muted" />
                  <a href={customer?.website || `https://${vendor?.contact?.website}`} target="_blank" rel="noopener noreferrer">
                    {customer?.website ? customer.website.replace(/^https?:\/\//, '') : vendor?.contact?.website}
                  </a>
                </li>
              </ul>
              {org.isVendorQuestionairreDisabled === false && (
                <>
                  <h6 className="section-heading mt-4">DATA ACCESS</h6>
                  {certificateDataAccess ? (
                    <>
                      <div className="vendor-tier mb-3">
                        <span className="badge badge-primary mr-2">Tier: {certificateDataAccess?.tier}</span>
                      </div>

                      <h6 className="sub-section-heading">Access Domains</h6>
                      <ul className="list-unstyled data-access">
                        {certificateDataAccess?.domains && certificateDataAccess?.domains?.map((domain, index) => (
                          <li key={index} className="mb-2">
                            <FontAwesomeIcon
                              icon={faCheck}
                              className="mr-2 text-success"
                            />
                            {domain}
                          </li>
                        ))}

                        {(!certificateDataAccess?.domains || certificateDataAccess?.domains?.length === 0) && (
                          <li className="text-muted">No access domains defined</li>
                        )}
                      </ul>
                    </>
                  ) : (
                    null
                  )}
                </>
              )}
            </div>

            {/* Right Column - Risk Information */}
            <div className="col-lg-9">
              <div className="vendor-risk-overview">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h5 className="mb-0 welcome-text">Risk Score Overview</h5>
                  {org.isVendorQuestionairreDisabled === false && (
                  <div className="text-muted small">
                    Last updated: {vendor.riskScores.lastUpdated}
                      <FontAwesomeIcon icon={faSync} className="ml-2 text-primary cursor-pointer" />
                    </div>
                  )}
                </div>

                {/* Risk Score Cards */}
                <div className="row mb-4">

                  {/* Security Posture */}
                  <div className="col-md-3">
                    <div className="card h-100 risk-score-card">
                      <div className="card-body text-center">
                        <h6 className="card-subtitle mb-2 text-muted">Security Posture</h6>
                        <div className="risk-score-circle">
                          <h2 className="mb-0">{ratingData}/800</h2>
                        </div>
                        <div className="risk-level mt-2 text-warning">
                          <FontAwesomeIcon icon={faExclamationTriangle} className="mr-1" />
                          <span>Medium Risk</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Risk Findings Section */}
                <div className="row mb-1">
                  <div className="col-12">
                    <ul className="nav nav-tabs mb-3">
                      {org.isVendorQuestionairreDisabled === false && (
                        <li className="nav-item">
                          <button
                            className={`nav-link ${activeTab === 'critical' ? 'active' : ''}`}
                            onClick={() => setActiveTab('critical')}
                          >
                            TPRM Findings
                          </button>
                        </li>
                      )}
                      <li className="nav-item">
                        <button
                          className={`nav-link ${activeTab === 'threatIntel' ? 'active' : ''}`}
                          onClick={() => setActiveTab('threatIntel')}
                        >
                          External Security Risks
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* Critical Findings */}
                {activeTab === 'critical' && org.isVendorQuestionairreDisabled === false && (
                  <div className="row">
                    <div className="col-12">
                      {criticalFindings && criticalFindings.riskRegisters && criticalFindings.riskRegisters.length > 0 ? (
                        <>
                          {criticalFindings.riskRegisters.map(finding => {
                            const severityInfo = getSeverityInfo(finding.riskLevel);

                            return (
                              <div
                                key={finding._id}
                                className={`card mb-3 ${severityInfo.borderClass}`}
                              >
                                <div className="card-body">
                                  <div className="d-flex align-items-center mb-2">
                                    <div
                                      className={`mr-3 p-2 rounded-circle ${severityInfo.bgColor}`}
                                      style={{ width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                    >
                                      <FontAwesomeIcon
                                        icon={severityInfo.icon}
                                        className="text-white"
                                      />
                                    </div>
                                    <h6 className="mb-0">{finding.title}</h6>
                                    <span className={`badge ${severityInfo.badgeClass} ml-2`}>
                                      {finding.status?.charAt(0).toUpperCase() + finding.status?.slice(1) || 'Open'}
                                    </span>
                                  </div>
                                  <p className="mb-2">{finding.riskNote}</p>
                                  <div className="d-flex text-muted small">
                                    <span className="mr-3">
                                      <span className={`badge ${severityInfo.badgeClass} mr-1`}>
                                        {severityInfo.label} Risk
                                      </span>
                                    </span>
                                    {finding.category && (
                                      <span className="mr-3">
                                        <FontAwesomeIcon icon={faFileAlt} className="mr-1" />
                                        Category: {finding.category?.categoryName || 'Uncategorized'}
                                      </span>
                                    )}
                                    {finding.questionForm && (
                                      <span>
                                        <FontAwesomeIcon icon={faClipboardCheck} className="mr-1" />
                                        Assessment: {finding.questionForm?.formTitle || 'Unknown Assessment'}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })}

                          {/* Pagination Controls */}
                          {totalFindings > findingsLimit && (
                            <div className="d-flex justify-content-between align-items-center mt-3">
                              <div className="text-muted small">
                                Showing {((findingsPage - 1) * findingsLimit) + 1} to {Math.min(findingsPage * findingsLimit, totalFindings)} of {totalFindings} findings
                              </div>
                              <div className="d-flex align-items-center">
                                <Pagination
                                  className="mb-0"
                                  currentPage={findingsPage}
                                  totalCount={totalFindings}
                                  pageSize={findingsLimit}
                                  onPageChange={(page) => setFindingsPage(page)}
                                />
                              </div>
                            </div>
                          )}
                        </>
                      ) : criticalFindings?.error ? (
                        <div className="alert alert-danger">
                          <FontAwesomeIcon icon={faExclamationCircle} className="mr-2" />
                          Failed to load critical findings. Please try again.
                        </div>
                      ) : (
                        <div className="text-center py-4">
                          <FontAwesomeIcon icon={faCheckCircle} size="3x" className="text-success mb-3" />
                          <h5>No Critical Findings</h5>
                          <p className="text-muted">No critical risk findings have been identified for this vendor</p>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Threat Intel Risk Tab Content */}
                {activeTab === 'threatIntel' && (
                  <div className="row">
                    <div className="col-12">
                      {isLoadingThreatIntel ? (
                        <div className="text-center py-4">
                          <div className="spinner-border text-primary" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                          <p className="mt-2 text-muted">Loading threat intelligence data...</p>
                        </div>
                      ) : threatIntelData ? (
                        <div className="threat-intel-container">
                          <div className="card mb-4">
                            <div className="card-body">
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <h6 className="card-subtitle text-muted">Risk Distribution</h6>
                                <button
                                  className="btn btn-outline-primary btn-sm"
                                  onClick={handleDownloadReport}
                                  disabled={!threatIntelData?.attackSurface?.length && !threatIntelData?.dataExposure?.length}
                                >
                                  <FontAwesomeIcon icon={faFileExcel} className="mr-2" />
                                  Download Report
                                </button>
                              </div>

                              {(threatIntelData?.attackSurface?.length > 0 || threatIntelData?.dataExposure?.length > 0) ? (
                                <div>
                                  {/* Attack Surface Risks */}
                                  {threatIntelData.attackSurface?.length > 0 && (
                                    <div className="mb-4">
                                      <h6 className="risk-category-title">
                                        <span className="badge badge-danger mr-2">
                                          <FontAwesomeIcon icon={faExclamationTriangle} className="mr-1" />
                                          Attack Surface Risks
                                        </span>
                                      </h6>
                                      <div className="table-responsive">
                                        <table className="table table-custom">
                                          <thead>
                                            <tr>
                                              <th>Risk Type</th>
                                              <th>Instances</th>
                                              <th>Description</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {threatIntelData.attackSurface.map((risk, index) => (
                                              <tr 
                                                key={`attack-${index}`}
                                                onClick={() => handleRiskNavigation(risk.module, id)}
                                                style={{ cursor: 'pointer' }}
                                                className="risk-row-hover"
                                              >
                                                <td>
                                                  <span className="font-weight-medium">{risk.moduleName}</span>
                                                </td>
                                                <td>
                                                  <span className="badge badge-danger">{risk.risk.split(' ')[0]}</span>
                                                </td>
                                                <td>{risk.risk}</td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  )}

                                  {/* Data Exposure Risks */}
                                  {threatIntelData.dataExposure?.length > 0 && (
                                    <div>
                                      <h6 className="risk-category-title">
                                        <span className="badge badge-warning mr-2">
                                          <FontAwesomeIcon icon={faShieldAlt} className="mr-1" />
                                          Data Exposure Risks
                                        </span>
                                      </h6>
                                      <div className="table-responsive">
                                        <table className="table table-custom">
                                          <thead>
                                            <tr>
                                              <th>Risk Type</th>
                                              <th>Instances</th>
                                              <th>Description</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {threatIntelData.dataExposure.map((risk, index) => (
                                              <tr 
                                                key={`data-${index}`}
                                                onClick={() => handleRiskNavigation(risk.module, id)}
                                                style={{ cursor: 'pointer' }}
                                                className="risk-row-hover"
                                              >
                                                <td>
                                                  <span className="font-weight-medium">{risk.moduleName}</span>
                                                </td>
                                                <td>
                                                  <span className="badge badge-warning">{risk.risk.split(' ')[0]}</span>
                                                </td>
                                                <td>{risk.risk}</td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <div className="text-center py-3">
                                  <FontAwesomeIcon icon={faCheckCircle} size="3x" className="text-success mb-3" />
                                  <h5>No Threat Intelligence Risks</h5>
                                  <p className="text-muted">No threat intelligence risks have been identified for this vendor</p>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="alert alert-warning">
                          <FontAwesomeIcon icon={faExclamationTriangle} className="mr-2" />
                          Failed to load threat intelligence data. Please try again later.
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>



      {/* Assessment History Section */}
      <div className="card mb-4">
        {org.isVendorQuestionairreDisabled === false && (
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h5 className="mb-0 welcome-text">Assessment History</h5>
          </div>

          {certificateAssessmentHistory?.data?.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-custom">
                <thead>
                  <tr>
                    <th>ASSESSMENT</th>
                    <th>STATUS</th>
                    <th>DUE DATE</th>
                    <th>START DATE</th>
                    <th>LAST UPDATED</th>
                    <th>ASSIGNED TO</th>
                    <th>ORGANIZATION</th>
                  </tr>
                </thead>
                <tbody>
                  {certificateAssessmentHistory.data.map(assessment => (
                    <tr key={assessment._id}>
                      <td>
                        <div className="d-flex align-items-center">
                          <div className="mr-3 assessment-icon">
                            <FontAwesomeIcon icon={faClipboardCheck} />
                          </div>
                          <div>
                            <div>{assessment.formTitle}</div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span className={`badge badge-${assessment.status === 'submitted' ? 'success' :
                          assessment.status === 'pending' ? 'warning' :
                            'info'
                          }`}>
                          {assessment.status.charAt(0).toUpperCase() + assessment.status.slice(1)}
                        </span>
                      </td>
                      <td>{new Date(assessment.dueDate).toLocaleDateString()}</td>
                      <td>{new Date(assessment.createdAt).toLocaleDateString()}</td>
                      <td>{new Date(assessment.updatedAt).toLocaleDateString()}</td>
                      <td>
                        {assessment.assignedUserEmails.map((email, index) => (
                          <div key={index}>{email}</div>
                        ))}
                      </td>
                      <td>{assessment.assigneeOrganisation}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center py-4">
              <FontAwesomeIcon icon={faClipboardCheck} size="3x" className="text-muted mb-3" />
              <h5>No assessments found</h5>
              <p className="text-muted">No assessment history is available for this vendor</p>
            </div>
          )}

          {certificateAssessmentHistory?.error && (
            <div className="alert alert-danger">
              Failed to load assessment history data. Please try again later.
            </div>
          )}
        </div>
        )}
      </div>

      {/* Documents & Evidence Section */}
      {org.isVendorQuestionairreDisabled === false && (
      <div className="ved-container">
        <div className="ved-header">
          <h3 className="ved-title welcome-text">Documents & Evidence</h3>
        </div>

        <div className="ved-search">
          <div className="ved-search-wrapper">
            <FontAwesomeIcon icon={faSearch} className="ved-search-icon" />
            <input
              type="text"
              className="ved-search-input"
              placeholder="Search documents..."
              onChange={(e) => setSearchName(e.target.value)}
            />
          </div>
        </div>

        <div className="ved-grid">
          {certificate?.data?.records?.map(doc => {
            // Determine file type icon and color based on name/type
            const fileExt = doc.name.split('.').pop()?.toLowerCase() || '';
            const fileTypeInfo = getFileTypeInfo(fileExt || doc.name);

            return (
              <div key={doc?._id} className="ved-item">
                <div className="ved-content">
                  <div>
                    <div className="ved-item-header">
                      <div className="ved-icon" style={{ backgroundColor: fileTypeInfo.bgColor }}>
                        <FontAwesomeIcon icon={faFilePdf} style={{ color: fileTypeInfo.color }} />
                      </div>
                      <div className="ved-actions">
                        <div className="dropdown">
                          <div className="dropdown-menu dropdown-menu-right">
                            <button
                              className="dropdown-item"
                              onClick={() => window.open(`/api/certificates/download/${doc._id}`, '_blank')}
                            >
                              <FontAwesomeIcon icon={faDownload} className="mr-2" />
                              Download
                            </button>
                            <button
                              className="dropdown-item text-danger"
                              onClick={() => {
                                if (window.confirm('Are you sure you want to delete this document?')) {
                                  deleteDocument(doc._id, _id, id, dispatch);
                                }
                              }}
                            >
                              <FontAwesomeIcon icon={faTimes} className="mr-2" />
                              Delete
                            </button>
                            {doc.policy.documentType === "private" && doc.requestStatus === null && (
                              <button
                                className="dropdown-item"
                                onClick={() => requestPrivatePolicy(doc._id, _id, dispatch)}
                              >
                                <FontAwesomeIcon icon={faFileContract} className="mr-2" />
                                Request Access
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ved-info">
                      <h4 className="ved-name">{doc.name}</h4>
                      <p className="ved-type">
                        {fileTypeInfo.label} {doc.size ? `• ${doc.size}` : ''}
                      </p>
                    </div>

                    {/* Display certificates */}
                    {doc.policyCertificatesAndControlsClassification &&
                      doc.policyCertificatesAndControlsClassification.length > 0 && (
                        <div className="ved-certificates">
                          {doc.policyCertificatesAndControlsClassification.map((cert, index) => (
                            <span key={cert._id || index} className={`ved-cert-badge ${getCertificateClass(cert.certificate)}`}>
                              {cert.certificate}
                            </span>
                          ))}
                        </div>
                      )}

                    <span className={`ved-tag ${getTagClass(doc.type || doc.policy.documentType)}`}>
                      {doc.category || doc.policy.documentType || 'Document'}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}

          {(!certificate || !certificate?.data?.records || certificate?.data?.records.length === 0) && (
            <div className="ved-empty">
              <FontAwesomeIcon icon={faFileAlt} className="ved-empty-icon" />
              <h5>No documents available</h5>
              <p>Upload documents or certificates to see them here</p>
            </div>
          )}
        </div>

        {/* Pagination */}
        <div className="ved-footer-controls">
          {totalItems > 0 && (
            <Pagination
              className="ved-pagination"
              currentPage={page}
              totalCount={totalItems}
              pageSize={limit}
              onPageChange={(page) => {
                setPage(page);
              }}
            />
          )}
          {totalItems > 10 && (
            <select
              value={limit}
              onChange={(e) => {
                setLimit(parseInt(e.target.value));
                setPage(1);
              }}
              className="ved-page-select"
            >
              <option value={10}>10 per page</option>
              <option value={25}>25 per page</option>
              <option value={50}>50 per page</option>
              <option value={100}>100 per page</option>
            </select>
          )}
        </div>
      </div>
      )}

      {/* Service Profiles Section */}
      {org.isVendorQuestionairreDisabled === false && (
      <div className="card mb-4">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h5 className="mb-0 welcome-text">Service Profiles</h5>
          </div>

          {serviceProfilesLoading ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <p className="mt-2 text-muted">Loading service profiles...</p>
            </div>
          ) : serviceProfiles.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-custom table-custom-service">
                <thead>
                  <tr>
                    <th>NAME</th>
                    <th>REGION</th>
                    <th>TIER</th>
                    <th>CREATED DATE</th>
                    <th>ACTIONS</th>
                  </tr>
                </thead>
                <tbody>
                  {serviceProfiles?.map((profile, index) => (
                    <tr key={index}>
                      <td>
                        <div className="d-flex align-items-center">
                          <div className="mr-3 service-profile-icon">
                            <FontAwesomeIcon icon={faFileAlt} />
                          </div>
                          <div>
                            <div className="font-weight-bold">{profile?.name}</div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span className="service-type">
                          {profile?.region || "N/A"}
                        </span>
                      </td>
                      <td>
                        <span className={`badge ${profile?.tier === 'High' ? 'badge-danger' :
                          profile?.tier === 'Medium' ? 'badge-warning' : 'badge-success'
                          }`}>
                          {profile?.tier}
                        </span>
                      </td>
                      <td>
                        {profile.createdAt ? formatDate(profile?.createdAt) : "N/A"}
                      </td>
                      <td>
                        <Link to="#"
                          onClick={() => {
                            setSelectedProfile(profile);
                            setShowProfileModal(true);
                          }}
                        >
                          <FontAwesomeIcon icon={faEye} className="mr-1" /> Details
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center py-4">
              <FontAwesomeIcon icon={faFileAlt} size="3x" className="text-muted mb-3" />
              <h5>No Service Profiles</h5>
              <p className="text-muted">No service profiles have been configured for this vendor</p>
            </div>
          )}

          {/* Service Profiles Pagination Controls */}
          {totalServiceProfiles > serviceProfilesLimit && (
            <div className="d-flex justify-content-between align-items-center mt-3">
              <div className="text-muted small">
                Showing {((serviceProfilesPage - 1) * serviceProfilesLimit) + 1} to {Math.min(serviceProfilesPage * serviceProfilesLimit, totalServiceProfiles)} of {totalServiceProfiles} service profiles
              </div>
              <div className="d-flex align-items-center">
                <Pagination
                  className="mb-0"
                  currentPage={serviceProfilesPage}
                  totalCount={totalServiceProfiles}
                  pageSize={serviceProfilesLimit}
                  onPageChange={(page) => setServiceProfilesPage(page)}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      )}

      {/* Service Profile Details Modal */}
      <div className={`modal fade ${showProfileModal ? 'd-block show' : ''}`} tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {selectedProfile?.name} - Service Profile Details
                <span className={`badge ml-2 ${selectedProfile?.tier === 'High' ? 'badge-danger' :
                  selectedProfile?.tier === 'Medium' ? 'badge-warning' : 'badge-success'
                  }`}>
                  Tier: {selectedProfile?.tier}
                </span>
              </h5>
              <button
                type="button"
                className="close"
                onClick={() => setShowProfileModal(false)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {selectedProfile && (
                <div>
                  <h6 className="border-bottom pb-2 mb-3">Access Domains</h6>
                  {selectedProfile?.domains && selectedProfile?.domains?.length > 0 ? (
                    <div className="row">
                      {selectedProfile?.domains?.map((domain, index) => (
                        <div className="col-md-6 mb-2" key={index}>
                          <div className="d-flex align-items-center domain-item p-2 border rounded">
                            <div className="domain-icon mr-2">
                              <FontAwesomeIcon icon={faCheckCircle} className="text-success" />
                            </div>
                            <div className="domain-name">
                              {domain.split('_').map(word =>
                                word.charAt(0).toUpperCase() + word.slice(1)
                              ).join(' ')}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="alert alert-info">
                      No domains have been configured for this service profile.
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Modal backdrop */}
      {showProfileModal && (
        <div
          className="modal-backdrop fade show"
          onClick={() => setShowProfileModal(false)}
        ></div>
      )}
    </div>
  );
};

export default VendorRiskDetails;
<style jsx>{`
  .domain-item {
    background-color: #f8f9fa;
    transition: all 0.2s;
  }
  .domain-item:hover {
    background-color: #e9ecef;
  }
  .domain-icon {
    width: 24px;
  }
  .domain-name {
    font-size: 0.9rem;
  }
  .modal.fade.show {
    opacity: 1;
  }
  .modal-backdrop.fade.show {
    opacity: 0.5;
  }
  .risk-row-hover:hover {
    background-color: #f8f9fa;
    transition: background-color 0.2s ease;
  }
  .risk-row-hover:hover td {
    border-color: #dee2e6;
  }
`}</style>